import { useState, useEffect } from 'react';
import { useErrorHandler } from '../../utils/useErrorHandler';
import { GOOGLE_API_KEY } from '../constants/user.constants';
import dataProvider from '../../services/api';

export const useApiKey = () => {
  const { handleErrorWithLogout } = useErrorHandler();
  const [apiKeyValue, setApiKeyValue] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchApiKey = async () => {
      try {
        const response = await dataProvider.getConfigurationValue({ name: GOOGLE_API_KEY });
        setApiKeyValue(response.data.value || null);
      } catch (error: any) {
        handleErrorWithLogout(error);
      } finally {
        setLoading(false);
      }
    };

    fetchApiKey();
  }, []);

  return { apiKeyValue, loading };
};